import React from 'react';
import ClipLoader from 'components/ClipLoader';
import style from './disconnected.module.scss'

interface Props {}

const Disconnected: React.FC<Props> = (props) => {

    return (
        <div className={style.disconnectedContainer}>
            <div className={style.loader}>
                <p>Disconnected...</p>
                <ClipLoader />
            </div>
        </div>
    )
}

export default Disconnected;